export default {

  LOAD_BANKS (state, banks) {
    state.items = banks
  }
}
